/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerFromJSON, UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerToJSON } from './UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInner';
export function UpdateContactSettingRequestContactSettingFieldsInnerFromJSON(json) {
    return UpdateContactSettingRequestContactSettingFieldsInnerFromJSONTyped(json, false);
}
export function UpdateContactSettingRequestContactSettingFieldsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        name: !exists(json, 'name') ? undefined : json['name'],
        contactSettingFieldItems: !exists(json, 'contact_setting_field_items')
            ? undefined
            : json['contact_setting_field_items'] === null
                ? null
                : json['contact_setting_field_items'].map(UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerFromJSON)
    };
}
export function UpdateContactSettingRequestContactSettingFieldsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        contact_setting_field_items: value.contactSettingFieldItems === undefined
            ? undefined
            : value.contactSettingFieldItems === null
                ? null
                : value.contactSettingFieldItems.map(UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerToJSON)
    };
}
